import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogComponent, Spinner, CheckboxesComponent } from '../../../Components';

export const OpenUnassignDialog = ({
  isOpen,
  setIsOpenAssignDialog,
  data,
  checkedCardsIds,
  reloadPage,
  parentTranslationPath,
  translationPath,
  RreqestAPI,
  isLoading,
  setIsPrimary,
  setIsResale,
  isResale,
  isPrimary,
  leadSelcted
}) => {
  const { t } = useTranslation(parentTranslationPath);
  const [isLoadingSave, setIsLoadingSave] = useState(false);
  const [isSaveIsDisabled, setIsSaveIsDisabled] = useState(true);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [isBothSelected, setIsBothSelected] = useState(false);

  useEffect(() => {
    setIsSaveIsDisabled(!(isPrimary || isResale));
  }, [isPrimary, isResale]);

  const handleBothCheckboxChange = (checked) => {
    setIsBothSelected(checked);
    if (checked) {
      setIsPrimary(true);
      setIsResale(true);
    } else {
      setIsPrimary(false);
      setIsResale(false);
    }
  };

  const handleSave = async (event) => {
    event.preventDefault();
    setIsLoadingSave(true);
    try {
      await RreqestAPI();
      setIsOpenAssignDialog(false);
      reloadPage();
    } catch (error) {
      console.error('Error during save:', error);
    } finally {
      setIsLoadingSave(false);
    }
  };

  useEffect(() => {
    if (leadSelcted?.isResale && leadSelcted?.isPrimary && isPrimary && isResale) {
      setIsBothSelected(true);
    }
  }, [isPrimary, isResale, leadSelcted]);
  return (
    <>
      <Spinner isActive={isLoadingSave} />
      <DialogComponent
        isOpen={isOpen}
        titleText={t(`${translationPath}Unassign-to-lead-owner`)}
        maxWidth="sm"
        onSaveClicked={handleSave}
        saveText="Confirm"
        onCancelClicked={() => {
          setIsOpenAssignDialog(false);
          setIsPrimary(false);
          setIsResale(false);

        }}
        saveIsDisabled={isLoading || isSaveIsDisabled || checkedCardsIds.length === 0}
        parentTranslationPath={parentTranslationPath}
        translationPath={translationPath}
        dialogContent={
          <>
            <div className="side-menu-actions">
              <div className="d-flex-center">{checkedCardsIds.length === 0 && t(`${translationPath}Select-Agent-TO-Unassign`)} </div>
            </div>
            {leadSelcted?.isResale && leadSelcted?.isPrimary && (
              <div className="form-item nassign-Both-Roles">
                <CheckboxesComponent
                  label={t(`${translationPath}Unassign-Both-Roles`)}
                  idRef="unassign-both-roles"
                  parentTranslationPath={parentTranslationPath}
                  translationPath={translationPath}
                  singleChecked={isBothSelected}
                  onSelectedCheckboxClicked={(e) => handleBothCheckboxChange(e.target.checked)}
                />
              </div>
            )}
            {leadSelcted?.isPrimary && (
              <div className="form-item">
                <CheckboxesComponent
                  label="Owner-Lead-Primary-Unassign"
                  parentTranslationPath={parentTranslationPath}
                  translationPath={translationPath}
                  idRef="Owner-primary-lead-owner"
                  singleChecked={isPrimary}
                  onSelectedCheckboxClicked={(e) => {
                    setIsPrimary(e.target.checked);
                    if (!e.target.checked) setIsBothSelected(false);
                  }}
                //isDisabled={isBothSelected}
                />
              </div>
            )}
            {leadSelcted?.isResale && (
              <div className="form-item">
                <CheckboxesComponent
                  idRef="unassign-resale-lead-owner"
                  label="Unassign-Resale-Lead-Owner"
                  parentTranslationPath={parentTranslationPath}
                  translationPath={translationPath}
                  singleChecked={isResale}
                  onSelectedCheckboxClicked={(e) => {
                    setIsResale(e.target.checked);
                    if (!e.target.checked) setIsBothSelected(false);
                  }}
                //isDisabled={isBothSelected}
                />
              </div>
            )}
          </>
        }
      />
    </>
  );
};